import React from "react";
import { Sequence, interpolate, spring } from "remotion";
import { GraphicNewsIntro } from "./Intro";
import { GraphicNewsHeader } from "./GraphicNewsHeader";
import { GraphicNewsInsights } from "./GraphicNewsInsights";
import { BaseTemplateProps } from "../BaseTemplate";

const OutroCTA: React.FC<{ keywords: string[]; frame: number; fps: number }> = ({
  keywords,
  frame,
  fps,
}) => {
  const opacity = interpolate(frame, [0, 8], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  const scale = spring({
    frame,
    fps,
    from: 0.85,
    to: 1,
    config: { damping: 12, stiffness: 100 },
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: "10px",
        marginTop: "20px",
        opacity,
        transform: `scale(${scale})`,
        zIndex: 20,
      }}
    >
      {/* STAY TUNED Slanted Badge */}
      <div
        style={{
          background: "#FFE600",
          border: "3px solid #000000",
          padding: "6px 18px",
          display: "inline-block",
          transform: "skewX(-8deg) rotate(1.5deg)",
          boxShadow: "3px 3px 0px #000000",
        }}
      >
        <span
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 900,
            fontSize: "14px",
            color: "#000000",
            letterSpacing: "2.5px",
            textTransform: "uppercase",
          }}
        >
          {keywords?.[0] || "STAY TUNED"}
        </span>
      </div>

      {/* HIT FOLLOW FOR DAILY UPDATES! */}
      <h3
        style={{
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: "48px",
          fontWeight: 900,
          color: "#111625",
          letterSpacing: "1.5px",
          textTransform: "uppercase",
          margin: "4px 0 0 0",
          lineHeight: 1.1,
        }}
      >
        HIT FOLLOW FOR DAILY UPDATES!
      </h3>
    </div>
  );
};

export const GraphicNewsTemplate: React.FC<BaseTemplateProps> = ({
  data,
  frame,
  fps,
  introFrames,
  bulletsFrames,
  outroFrames,
  headerOpacity,
  headerScale,
  headerTranslateY,
}) => {
  const isOutro = frame >= introFrames + bulletsFrames;
  const outroElapsed = Math.max(0, frame - (introFrames + bulletsFrames));

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "100%",
        height: "100%",
      }}
    >
      {/* Phase 1: Intro Hook */}
      <Sequence durationInFrames={introFrames}>
        <GraphicNewsIntro
          headline={data.headline}
          keywords={data.keywords ?? []}
          frame={frame}
          fps={fps}
        />
      </Sequence>

      {/* Phase 2 & 3: Bullets + Outro */}
      <Sequence from={introFrames} durationInFrames={bulletsFrames + outroFrames}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            gap: "24px",
            alignItems: "center",
          }}
        >
          {/* Header */}
          <GraphicNewsHeader
            data={data}
            opacity={isOutro ? 1 : headerOpacity}
            scale={isOutro ? 1 : headerScale}
            translateY={isOutro ? 0 : headerTranslateY}
          />

          {/* Insights Card */}
          <GraphicNewsInsights
            bullets={data.bulletTimings}
            // Freeze card to show the final bullet during the outro phase
            globalFrame={isOutro ? introFrames + bulletsFrames - 1 : frame}
          />

          {/* Outro CTA below card during Phase 3 */}
          {isOutro && (
            <OutroCTA
              keywords={data.keywords ?? []}
              frame={outroElapsed}
              fps={fps}
            />
          )}
        </div>
      </Sequence>
    </div>
  );
};


;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
